import {NgModule} from '@angular/core';
import {ActivatedRouteSnapshot, RouterModule, Routes} from '@angular/router';
import {WelkomComponent} from './welkom/welkom.component';
import {DorpelPageComponent} from './dorpel-page/dorpel-page.component';
import {OverzichtComponent} from './overzicht/overzicht.component';
import {RedirectComponent} from './redirect/redirect.component';
import {DealersComponent} from './dealers/dealers.component';
import { LuvemaLandingComponent } from './landing-pages/luvema-landing.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/products',
    pathMatch: 'full'
  },
  {
    path: 'products',
    component:  DealersComponent
  },
  {
    path: ':dealerGuid',
    redirectTo: '/products/:dealerGuid',
    pathMatch: 'full'
  },
  {
    path: 'products/Luvema',
    component:  LuvemaLandingComponent,
    pathMatch: 'full'
  },
  {
    path: 'products/:dealerGuid',
    component:  DealersComponent
  },
  {
    path: 'order-form/:productType',
    children: [
      {
        path: '',
        component: WelkomComponent,
        canActivate: ['routecheck']
      },
      {
        path: 'dorpel',
        component: DorpelPageComponent,
      },
      {
        path: 'overzicht',
        component: OverzichtComponent
      },
      {
        path: 'redirect',
        component:  RedirectComponent // added this for routing from overzicht to redirect
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: "routecheck",
      useValue: (route: ActivatedRouteSnapshot) => {
        const productType = route.paramMap.get('productType'); // Get the route parameter
        return productType !== "Luvema"
      }
    }
  ]
})
export class AppRoutingModule { }
